<template>
  <b-card>
    <div slot="header" v-html="caption"></div>
    <b-table
      :dark="dark"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      responsive="sm"
      :items="items"
      :fields="captions"
    >
      <template v-slot:cell(status)="{ value }">
        <b-badge :variant="getBadge(value)">{{ value }}</b-badge>
      </template>
      <template v-slot:cell(fnsid)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <a target="_blank"
          v-bind:href="
            envVar +
              'tracker_private/includes/customerReportPublic.php?ftrack=' +
              data.value + '-' + data.item.fnsra
          "
          >{{ data.value }}</a
        >
      </template>
    </b-table>
    <!--    <nav>-->
    <!--      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>-->
    <!--    </nav>-->
  </b-card>
</template>

<script>
export default {
  name: "Table",
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      envVar: process.env.VUE_APP_TRACKER_URL
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    },
    link: function() {
      return (
        this.envVar +
        "tracker_private/includes/FNSReport.php?ftrack=" +
        this.item
      );
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    }
  }
};
</script>
